// extracted by mini-css-extract-plugin
export default {"navColor":"Navbar_navColor__PmpD8","navLogo":"Navbar_navLogo__MZirC","logo":"Navbar_logo__YAtzK","navBtn":"Navbar_navBtn__zZo4U","dots":"Navbar_dots__ApRjB"};